// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Yp-z","imageAndVideoCount":"Zp-z","imageAndVideoContainer":"_p-z","viewAllReviews":"aq-z"};